import { instance } from "libs/api";

import { ApiRoutesInternalBank } from "../../constants";
import { InternalBankingData } from "../../financial.types";

export const requestInternalBank = async (): Promise<InternalBankingData> => {
  return await instance.get(ApiRoutesInternalBank.InternalBank);
};
